import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { useTenantId } from "@shared/selectors/globalSelectors";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
import { getGLCode, getSummary, getUtilityServices, updateGlCode } from "./api";

export const useBillDetails = (queryParams?: Record<string, any>) => {
  return useSmartQuery(
    [QueryKeyFactory.module.bx.glCode.glCodeList(), queryParams],
    () => getGLCode(queryParams)
  );
};

export const useUtilityServices = () => {
  return useSmartQuery(
    [
      QueryKeyFactory.module.bx.glCode.utilityServiceList(),
      getRemoteUtilityId(),
    ],
    () => getUtilityServices(),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    }
  );
};

export const useUpdateGlCode = () => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const tenantId = useTenantId();

  return useSmartMutation(
    async ({ entityName, item }: { entityName: string; item: any }) => {
      const today = new Date().toISOString().split("T")[0];
      const payload = {
        remote_utility_id: REMOTE_UTILITY_ID,
        remote_tenant_id: tenantId,
        configuration_json: {
          [`${entityName}`]: {
            gl_code_id: item.id,
            is_active: item.isActiveStatus,
            gl_code_value: item.configuredGlCodeValue,
            created_date: today,
          },
        },
      };

      return updateGlCode(JSON.stringify(payload));
    }
  );
};

export const useSummary = () => {
  return useSmartQuery(
    [QueryKeyFactory.module.bx.glCode.summary(), getRemoteUtilityId()],
    () => getSummary(),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    }
  );
};
